import React, { useRef, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { reportContactConversion } from "@/lib/googleAds";

const API = "/api";

export const inputCls =
  "w-full bg-[#0B0C10] border border-[rgba(197,168,128,0.25)] rounded-lg px-4 py-3 text-sm text-[#F4F3EF] placeholder-[#6b7280] focus:outline-none focus:border-[#C5A880] focus:ring-1 focus:ring-[#C5A880]/40 transition-colors duration-300";

export const BUDGET_OPTIONS = [
  "Below AED 2m",
  "AED 2m-5m",
  "AED 5m-10m",
  "AED 10m-50m",
  "Budget not constrained",
  "Land development budget",
  "Prefer to discuss privately",
];

const EnquiryForm = ({ projectName, sourcePage }) => {
  const [form, setForm] = useState({ full_name: "", whatsapp: "", email: "", budget_range: "", message: "" });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const conversionReported = useRef(false);
  const submissionInFlight = useRef(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (submissionInFlight.current || done) return;
    submissionInFlight.current = true;
    setLoading(true);
    try {
      await axios.post(`${API}/enquiries`, { ...form, project_name: projectName, source_page: sourcePage });
      if (!conversionReported.current) {
        conversionReported.current = true;
        reportContactConversion();
      }
      setDone(true);
      toast.success("Enquiry received. Our advisory team will be in touch shortly.");
    } catch (err) {
      toast.error("Something went wrong. Please try again or reach us on WhatsApp.");
    } finally {
      submissionInFlight.current = false;
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div className="bg-[#13151D] border border-[rgba(197,168,128,0.3)] rounded-2xl p-8 text-center" data-testid="enquiry-success">
        <p className="font-display text-2xl text-[#E6CA65] mb-3">Request received</p>
        <p className="text-sm text-[#9DA3AE] font-light">
          Thank you, {form.full_name.split(" ")[0]}. The brochure and latest availability for {projectName} will be shared
          with you personally by the ACRE advisory team.
        </p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="bg-[#13151D] border border-[rgba(197,168,128,0.25)] rounded-2xl p-7 space-y-4" data-testid="project-enquiry-form">
      <p className="eyebrow">Private Enquiry</p>
      <h3 className="font-display text-2xl text-[#F4F3EF]">Request Brochure & Availability</h3>
      <input type="hidden" name="project_name" value={projectName} />
      <input type="hidden" name="source_page" value={sourcePage} />
      <div>
        <label htmlFor="eq-name" className="text-xs text-[#9DA3AE] block mb-1.5">Full name *</label>
        <input id="eq-name" data-testid="enquiry-name-input" required className={inputCls} value={form.full_name} onChange={set("full_name")} placeholder="Your full name" />
      </div>
      <div>
        <label htmlFor="eq-whatsapp" className="text-xs text-[#9DA3AE] block mb-1.5">WhatsApp number (with country code) *</label>
        <input id="eq-whatsapp" data-testid="enquiry-whatsapp-input" required className={inputCls} value={form.whatsapp} onChange={set("whatsapp")} placeholder="+44 ..." />
      </div>
      <div>
        <label htmlFor="eq-email" className="text-xs text-[#9DA3AE] block mb-1.5">Email *</label>
        <input id="eq-email" data-testid="enquiry-email-input" required type="email" className={inputCls} value={form.email} onChange={set("email")} placeholder="you@example.com" />
      </div>
      <div>
        <label htmlFor="eq-budget" className="text-xs text-[#9DA3AE] block mb-1.5">Budget range (optional)</label>
        <select id="eq-budget" data-testid="enquiry-budget-select" className={inputCls} value={form.budget_range} onChange={set("budget_range")}>
          <option value="">Select a range</option>
          {BUDGET_OPTIONS.map((o) => (
            <option key={o} value={o}>{o}</option>
          ))}
        </select>
      </div>
      <div>
        <label htmlFor="eq-message" className="text-xs text-[#9DA3AE] block mb-1.5">Message (optional)</label>
        <textarea id="eq-message" data-testid="enquiry-message-input" rows={3} className={inputCls} value={form.message} onChange={set("message")} placeholder="Anything we should know?" />
      </div>
      <button
        type="submit"
        disabled={loading}
        data-testid="enquiry-submit-button"
        className="w-full text-sm uppercase tracking-[0.14em] font-semibold px-6 py-4 rounded-full text-[#0B0C10] bg-gradient-to-r from-[#E6CA65] via-[#C5A880] to-[#9A7B4F] hover:shadow-[0_0_24px_rgba(197,168,128,0.45)] transition-shadow duration-300 disabled:opacity-60"
      >
        {loading ? "Sending..." : "Request Brochure & Availability"}
      </button>
    </form>
  );
};

export default EnquiryForm;
